<cdx-slotted-modal
	center="true"
	[size]="modalSize.Large"
	[mobileFullHeight]="true"
	[showBack]="modalInHistory"
	(close)="onClose()"
	(back)="goBack()"
>
	<div modal-header>
		<div class="near-stores-heading">
			<div class="col">
				<figure
					cdxProductImage
					[images]="mainImage"
					[name]="product?.name"
					size="extra-small"
					ImageZoom
					labelledBy="product-title"
				></figure>
			</div>
			<div class="col">
				<h5 class="product-title">{{ product?.name | titlecase | capitalizeSpecificWords }}</h5>
			</div>
		</div>
	</div>
	<div modal-content>
		<ng-container *ngIf="loading">
			<cdx-wapple-loading></cdx-wapple-loading>
		</ng-container>

		<div *ngIf="!currentLocationError" class="near-stores-content">
			<h5 style="text-align: left">Nearby stores</h5>
			<div class="searchResults-storeList">
				<cdx-accordion
					*ngIf="!!this.searchResults"
					class="near-stores-accordion accordion--light accordion-header--gap accordion-header--round"
				>
					<cdx-accordion-item
						#storeAccordion
						*ngFor="let result of searchResults; let i = index; trackBy: trackByFn"
						[analyticsNotificationType]="notificationType.Modal"
						[analyticsID]="getStoreAccordionAnalyticsId(storeAccordion)"
						[analyticsValue]="result.site.name"
					>
						<div heading style="width: 100%">
							<div class="store-name">{{ result.site?.name }}</div>
							<div class="store-info">
								<wnz-product-stock-level-indicator [stockLevel]="result.stockLevel">
								</wnz-product-stock-level-indicator>
								<div class="store-distance">
									<cdx-svg-icon class="location-icon" size="small" name="location-pin-filled" fill="gray">
									</cdx-svg-icon>
									<div class="store-distance--info">{{ result.distanceInKms }} km away</div>
								</div>
							</div>
						</div>
						<address class="left">
							{{ result.site?.addressLine1 }}<br />
							{{ result.site?.suburb }} <br />
						</address>
						<ng-container *ngIf="result.isOpen; else closed">
							<p class="store-hours" i18n="@@storeSummary-open">
								<strong class="store-hours--open">Open</strong> Closes at
								{{ result.closingTime | formattedDate: 'time' }}
							</p>
						</ng-container>
						<ng-template #closed>
							<p class="store-hours" i18n="@@storeSummary-closed">
								<strong class="store-hours--closed">Closed</strong>
								<span *ngIf="result.expectedOpeningTime">
									Opens
									{{
										result.expectedOpeningTime
											| formattedDate
												: 'dayOfWeekWithDate'
												: {
														sameDay: 'time',
														nextDay: 'dayOfWeekWithTime'
												  }
									}}
								</span>
							</p>
						</ng-template>
						<div class="summaryBody-actions">
							<div>
								<a
									cdxButton
									class="link store-info-btn"
									fillStyle="outline"
									[href]="result.storeInfoUrl"
									target="_self"
									i18n="@@storeSummary-storeDetails"
									[cdxTrackEvent]="{
										event: trackingEvent.NotificationEvent,
										type: notificationType.Modal,
										name: 'stock availability store info',
										value: result.site.name
									}"
									>Store info</a
								>
								<a
									cdxButton
									class="link get-directions-btn"
									fillStyle="outline"
									[href]="result.directionsUrl"
									target="_blank"
									i18n="@@storeSummary-directions"
									[cdxTrackEvent]="{
										event: trackingEvent.NotificationEvent,
										type: notificationType.Modal,
										name: 'stock availability get directions',
										value: result.site.name
									}"
									>Get directions</a
								>
							</div>
							<button
								class="shop-from-this-store-btn"
								cdxButton
								fillStyle="primary"
								[fullWidth]="true"
								aria-live="polite"
								(click)="
									changePickupStoreAndAddToTrolley(result.site.id, result.fulfilmentStoreId, result.pickupAddressId, result.stockLevel)
								"
								[cdxTrackEvent]="{
									event: trackingEvent.NotificationEvent,
									type: notificationType.Modal,
									name: 'stock availability shop store',
									value: result.site.name
								}"
							>
								Shop from this store
							</button>
						</div>
					</cdx-accordion-item>
				</cdx-accordion>
			</div>
		</div>

		<! -- If the user didn't consent to share their current location -->
		<cdx-alert
			*ngIf="currentLocationError"
			icon="alert"
			type="error"
			description="Unable to retrieve your current location."
		>
		</cdx-alert>
	</div>

	<div modal-footer-primary class="footer-container">
		<button
			*ngIf="!currentLocationError && searchResults?.length < storeCountMax"
			cdxButton
			(click)="onLoadMoreStoresClicked()"
			fillStyle="outline"
			class="show-more-stores"
			[cdxTrackEvent]="{
				event: trackingEvent.NotificationEvent,
				type: notificationType.Modal,
				name: 'stock availability other stores',
				value: ''
			}"
		>
			Show more stores
		</button>
	</div>
</cdx-slotted-modal>
